<template>
  <div class="login">
    <div class="login-box login-form">
      <form>
        <div class="login-logo">
          <img src="../assets/img/logo.png" alt="">
        </div>
        <div class="login-item">
          <el-input placeholder="请输入手机号" v-model="info.phone"></el-input>
        </div>
        <div class="login-item">
          <el-input placeholder="请输入密码" v-model="info.password" show-password></el-input>
        </div>
        <div class="login-opt-box">
          <div class="login-opt" :class="info.userType === '2' ? 'login-opt-this' : ''" @click="changeType('2')">市区代理</div>
          <div class="login-opt" :class="info.userType === '1' ? 'login-opt-this' : ''" @click="changeType('1')">省区总代理</div>
        </div>
        <div v-loading="loading">
          <el-button type="primary" @click="submit()" class="login-btn">登录</el-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      loading: false,
      info: {
        userType: '',
        phone: '',
        password: ''
      }
    }
  },
  methods: {
    changeType (type) {
      this.info.userType = type
    },
    submit () {
      let _this = this
      _this.loading = true
      let reg = /^1[3456789]\d{9}$/
      if (!reg.test(_this.info.phone)) {
        this.$message.error('请输入有效的手机号码')
        _this.loading = false
        return
      }
      if (_this.info.password === '') {
        this.$message.error('请输入密码')
        _this.loading = false
        return
      }
      if (this.info.userType === '') {
        this.$message.error('请选择登录类型')
        _this.loading = false
        return
      }
      this.$axios.post('/common/login', _this.info)
        .then((res) => {
          if (res.status === 200) {
            _this.$message({
              message: '登陆成功,即将跳转...',
              duration: 800,
              type: 'success',
              center: true,
              onClose: function () {
                _this.loading = false
                _this.$store.commit('$_setStorage', res.data)
                _this.$router.push({path: '/salesman/salesman'})
              }
            })
          } else {
            _this.$message.error(res.msg)
            _this.loading = false
          }
        })
        .catch(function (error) {
          _this.$alert(error.message, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              _this.loading = false
            }
          })
        })
    }
  }
}
</script>

<style scoped src="../assets/css/login.css"></style>



// WEBPACK FOOTER //
// src/components/Login.vue